// Defines the canonical capability vocabulary used by the current app.
import { createEntitlementRegistry } from '../application/createEntitlementRegistry';

export const defaultEntitlementRegistry = createEntitlementRegistry([
  {
    key: 'businesses.max',
    kind: 'limit',
    valueType: 'number',
    label: 'Max businesses',
    description: 'Maximum number of businesses a subject may create.',
    scope: 'business',
    defaultValue: null,
  },
  {
    key: 'sports.max',
    kind: 'limit',
    valueType: 'number',
    label: 'Max sports',
    description: 'Maximum number of active sports a business may expose.',
    scope: 'business',
    defaultValue: null,
  },
  {
    key: 'courts.total.max',
    kind: 'limit',
    valueType: 'number',
    label: 'Max total courts',
    description: 'Maximum number of active courts a business may expose in total.',
    scope: 'business',
    defaultValue: null,
  },
  {
    key: 'courts.per_sport.max',
    kind: 'limit',
    valueType: 'number',
    label: 'Max courts per sport',
    description: 'Maximum number of active courts a business may expose per sport.',
    scope: 'sport',
    defaultValue: null,
  },
  {
    key: 'courts.max',
    kind: 'limit',
    valueType: 'number',
    label: 'Max courts (legacy)',
    description: 'Legacy compatibility alias for total court limits during migration.',
    scope: 'business',
    defaultValue: null,
  },
  {
    key: 'activity_logs.page_size.max',
    kind: 'limit',
    valueType: 'number',
    label: 'Max activity logs per page',
    description: 'Maximum number of activity log rows returned per page.',
    scope: 'user',
    defaultValue: null,
  },
  {
    key: 'activity_logs.total_rows.max',
    kind: 'limit',
    valueType: 'number',
    label: 'Max visible activity logs',
    description: 'Maximum number of activity log rows visible in the UI.',
    scope: 'user',
    defaultValue: null,
  },
  {
    key: 'activity_logs.pages.max',
    kind: 'limit',
    valueType: 'number',
    label: 'Max activity log pages',
    description: 'Maximum number of activity log pages visible to a user.',
    scope: 'user',
    defaultValue: null,
  },
  {
    key: 'activity_logs.lookback.max_age_hours',
    kind: 'limit',
    valueType: 'number',
    label: 'Max activity log lookback age',
    description: 'Maximum age in hours for visible activity logs.',
    scope: 'user',
    defaultValue: null,
  },
]);

